import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version — night-visibility
export const nightVisibilityMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-nv-1',
    text: {
      en: 'When must you use dipped headlights at night?',
      nl: 'Wanneer moet u \'s nachts dimlicht gebruiken?',
      ar: 'متى يجب استخدام المصابيح المنخفضة (القصيرة) ليلا؟',
    },
    options: [
      {
        id: 'q-nv-1o1',
        text: {
          en: 'Only on unlit roads',
          nl: 'Alleen op onverlichte wegen',
          ar: 'فقط على الطرق غير المضاءة',
        },
      },
      {
        id: 'q-nv-1o2',
        text: {
          en: 'On all roads at night; use main beam only when you cannot dazzle others',
          nl: 'Op alle wegen \'s nachts; gebruik groot licht alleen wanneer u anderen niet kunt verblinden',
          ar: 'على جميع الطرق ليلا؛ استخدم الضوء العالي فقط عندما لا تعمي الآخرين',
        },
      },
      {
        id: 'q-nv-1o3',
        text: {
          en: 'Only on motorways',
          nl: 'Alleen op autosnelwegen',
          ar: 'فقط على الطرق السريعة',
        },
      },
    ],
    correctAnswerId: 'q-nv-1o2',
    explanation: {
      en: 'Use dipped headlights at night on all roads. Use main beam only when you cannot dazzle oncoming traffic or vehicles ahead.',
      nl: 'Gebruik \'s nachts dimlicht op alle wegen. Gebruik groot licht alleen wanneer u het tegemoetkomende verkeer of voertuigen voor u niet kunt verblinden.',
      ar: 'استخدم المصابيح المنخفضة ليلا على جميع الطرق. استخدم الضوء العالي فقط عندما لا تعمي المركبات المقابلة أو المركبات أمامك.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-2',
    text: {
      en: 'When should you dip your headlights?',
      nl: 'Wanneer moet u dimlicht gebruiken?',
      ar: 'متى يجب أن تخفض المصابيح (أن تستخدم الضوء المنخفض)؟',
    },
    options: [
      {
        id: 'q-nv-2o1',
        text: {
          en: 'Only when police ask',
          nl: 'Alleen wanneer de politie dit vraagt',
          ar: 'فقط عندما يطلب الشرطي ذلك',
        },
      },
      {
        id: 'q-nv-2o2',
        text: {
          en: 'When meeting oncoming traffic or following another vehicle closely',
          nl: 'Bij tegemoetkomend verkeer of wanneer u dicht achter een ander voertuig rijdt',
          ar: 'عند لقاء مركبات مقابلة أو عند متابعة مركبة أخرى عن قرب',
        },
      },
      {
        id: 'q-nv-2o3',
        text: {
          en: 'Never; main beam is safer',
          nl: 'Nooit; groot licht is veiliger',
          ar: 'أبدا؛ الضوء العالي أكثر أمانا',
        },
      },
    ],
    correctAnswerId: 'q-nv-2o2',
    explanation: {
      en: 'Dip your headlights when you would dazzle oncoming drivers or when following another vehicle so you do not dazzle them in the mirror.',
      nl: 'Gebruik dimlicht wanneer u tegemoetkomende bestuurders zou verblinden of wanneer u een ander voertuig volgt, zodat u hen niet in de spiegel verblindt.',
      ar: 'خفض المصابيح عندما قد تعمي السائقين المقابلين أو عند متابعة مركبة أخرى حتى لا تعميهم في المرآة.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-3',
    text: {
      en: 'What should you do if you are dazzled by oncoming headlights?',
      nl: 'Wat moet u doen als u wordt verblind door tegemoetkomende koplampen?',
      ar: 'ماذا يجب أن تفعل إذا أعماك ضوء المصابيح القادمة من الأمام؟',
    },
    options: [
      {
        id: 'q-nv-3o1',
        text: {
          en: 'Look at the headlights to see the car',
          nl: 'Naar de koplampen kijken om de auto te zien',
          ar: 'أن تنظر إلى المصابيح لترى السيارة',
        },
      },
      {
        id: 'q-nv-3o2',
        text: {
          en: 'Slow down or stop if necessary; look toward the left edge of the road',
          nl: 'Vertragen of indien nodig stoppen; naar de linker kant van de weg kijken',
          ar: 'أن تبطئ أو تتوقف عند الضرورة؛ أن تنظر نحو الحافة اليسرى للطريق',
        },
      },
      {
        id: 'q-nv-3o3',
        text: {
          en: 'Flash your main beam in response',
          nl: 'Met groot licht terugflitsen',
          ar: 'أن تومض بالضوء العالي ردا',
        },
      },
    ],
    correctAnswerId: 'q-nv-3o2',
    explanation: {
      en: 'If dazzled, slow down or stop if needed. Look toward the left edge of the road until the other vehicle has passed.',
      nl: 'Als u wordt verblind, vertraagt u of stopt u indien nodig. Kijk naar de linker kant van de weg totdat het andere voertuig is gepasseerd.',
      ar: 'إذا أعميت، أبطئ أو توقف عند الحاجة. انظر نحو الحافة اليسرى للطريق حتى تمر المركبة الأخرى.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-4',
    text: {
      en: 'When may you use front fog lights?',
      nl: 'Wanneer mag u mistlicht voor gebruiken?',
      ar: 'متى يجوز لك استخدام مصابيح الضباب الأمامية؟',
    },
    options: [
      {
        id: 'q-nv-4o1',
        text: {
          en: 'Whenever it is dark',
          nl: 'Wanneer het maar donker is',
          ar: 'كلما كان الظلام',
        },
      },
      {
        id: 'q-nv-4o2',
        text: {
          en: 'In fog or when visibility is seriously reduced',
          nl: 'Bij mist of wanneer het zicht ernstig is beperkt',
          ar: 'في الضباب أو عندما تنخفض الرؤية بشكل كبير',
        },
      },
      {
        id: 'q-nv-4o3',
        text: {
          en: 'On motorways only',
          nl: 'Alleen op autosnelwegen',
          ar: 'على الطرق السريعة فقط',
        },
      },
    ],
    correctAnswerId: 'q-nv-4o2',
    explanation: {
      en: 'Use front fog lights only when visibility is seriously reduced (e.g. fog, heavy rain). Switch them off when visibility improves.',
      nl: 'Gebruik mistlicht voor alleen wanneer het zicht ernstig is beperkt (bijv. mist, zware regen). Schakel het uit wanneer het zicht verbetert.',
      ar: 'استخدم مصابيح الضباب الأمامية فقط عندما تنخفض الرؤية بشكل كبير (مثل الضباب أو المطر الغزير). أطفئها عند تحسن الرؤية.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-5',
    text: {
      en: 'Why is it harder to judge speed and distance at night?',
      nl: 'Waarom is het \'s nachts moeilijker om snelheid en afstand in te schatten?',
      ar: 'لماذا يصعب تقدير السرعة والمسافة ليلا؟',
    },
    options: [
      {
        id: 'q-nv-5o1',
        text: {
          en: 'It is not; it is the same',
          nl: 'Dat is niet zo; het is hetzelfde',
          ar: 'ليس الأمر كذلك؛ الوضع نفسه',
        },
      },
      {
        id: 'q-nv-5o2',
        text: {
          en: 'You have less visual information; headlights only show a limited area',
          nl: 'U heeft minder visuele informatie; koplampen tonen slechts een beperkt gebied',
          ar: 'لديك معلومات بصرية أقل؛ تظهر المصابيح منطقة محدودة فقط',
        },
      },
      {
        id: 'q-nv-5o3',
        text: {
          en: 'Other drivers drive faster',
          nl: 'Andere bestuurders rijden sneller',
          ar: 'السائقون الآخرون يقودون أسرع',
        },
      },
    ],
    correctAnswerId: 'q-nv-5o2',
    explanation: {
      en: 'At night you see less of the road and other vehicles. It is harder to judge their speed and distance, so drive with extra care.',
      nl: "'s Nachts ziet u minder van de weg en andere voertuigen. Het is moeilijker om hun snelheid en afstand in te schatten; rijd daarom extra voorzichtig.",
      ar: 'ليلا ترى أقل من الطريق والمركبات الأخرى. يصعب تقدير سرعتها ومسافتها، فقد بحذر إضافي.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-limited-visibility.jpg',
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-6',
    text: {
      en: 'When driving at night in built-up areas with street lighting, what lights should you use?',
      nl: 'Welke verlichting moet u gebruiken als u \'s nachts in een bebouwde kom met straatverlichting rijdt?',
      ar: 'عند القيادة ليلا في مناطق مبنية مضاءة بإنارة الشوارع، ما الإضاءة التي يجب استخدامها؟',
    },
    options: [
      {
        id: 'q-nv-6o1',
        text: {
          en: 'No lights; street lights are enough',
          nl: 'Geen verlichting; straatverlichting is voldoende',
          ar: 'دون أضواء؛ إنارة الشوارع كافية',
        },
      },
      {
        id: 'q-nv-6o2',
        text: {
          en: 'Dipped headlights so you can see and be seen',
          nl: 'Dimlicht, zodat u kunt zien en gezien wordt',
          ar: 'المصابيح المنخفضة حتى ترى ويراك الآخرون',
        },
      },
      {
        id: 'q-nv-6o3',
        text: {
          en: 'Main beam for better visibility',
          nl: 'Groot licht voor beter zicht',
          ar: 'الضوء العالي لرؤية أفضل',
        },
      },
    ],
    correctAnswerId: 'q-nv-6o2',
    explanation: {
      en: 'Use dipped headlights at night even in lit areas so you can see the road and other road users can see you.',
      nl: 'Gebruik \'s nachts dimlicht, ook in verlichte gebieden, zodat u de weg kunt zien en andere weggebruikers u kunnen zien.',
      ar: 'استخدم المصابيح المنخفضة ليلا حتى في المناطق المضاءة حتى ترى الطريق ويراك مستخدمو الطريق الآخرون.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-7',
    text: {
      en: 'What should you do if the sun is low and causing glare?',
      nl: 'Wat moet u doen als de zon laag staat en verblinding veroorzaakt?',
      ar: 'ماذا تفعل إذا كانت الشمس منخفضة في الأفق وتسبب وهجا يعيق الرؤية؟',
    },
    options: [
      {
        id: 'q-nv-7o1',
        text: {
          en: 'Speed up to get out of the glare',
          nl: 'Versnellen om uit de verblinding te komen',
          ar: 'أن تزيد السرعة لتخرج من الوهج',
        },
      },
      {
        id: 'q-nv-7o2',
        text: {
          en: 'Slow down, use sun visor, and keep a safe distance; be prepared for others who cannot see well',
          nl: 'Vertragen, zonneklep gebruiken en veilige afstand houden; wees voorbereid op anderen die slecht kunnen zien',
          ar: 'أن تبطئ وتستخدم مظلة الشمس وتحافظ على مسافة آمنة؛ كن مستعدا لمن لا يرى جيدا',
        },
      },
      {
        id: 'q-nv-7o3',
        text: {
          en: 'Use main beam to compensate',
          nl: 'Groot licht gebruiken om te compenseren',
          ar: 'أن تستخدم الضوء العالي للتعويض',
        },
      },
    ],
    correctAnswerId: 'q-nv-7o2',
    explanation: {
      en: 'Glare reduces visibility. Slow down, use the sun visor, and keep a safe distance. Others may also be affected.',
      nl: 'Verblinding beperkt het zicht. Vertraag, gebruik de zonneklep en houd een veilige afstand. Anderen kunnen ook worden beïnvloed.',
      ar: 'الوهج يقلل الرؤية. أبطئ واستخدم مظلة الشمس واحتفظ بمسافة آمنة. قد يتأثر الآخرون أيضا.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-8',
    text: {
      en: 'When may you use rear fog lights?',
      nl: 'Wanneer mag u mistlicht achter gebruiken?',
      ar: 'متى يجوز لك استخدام مصابيح الضباب الخلفية؟',
    },
    options: [
      {
        id: 'q-nv-8o1',
        text: {
          en: 'Whenever it is raining',
          nl: 'Wanneer het maar regent',
          ar: 'كلما أمطرت',
        },
      },
      {
        id: 'q-nv-8o2',
        text: {
          en: 'When visibility is seriously reduced (e.g. fog); switch off when it improves',
          nl: 'Wanneer het zicht ernstig is beperkt (bijv. mist); uitschakelen wanneer het zicht verbetert',
          ar: 'عندما تنخفض الرؤية بشكل كبير (مثل الضباب)؛ أطفئها عند تحسن الرؤية',
        },
      },
      {
        id: 'q-nv-8o3',
        text: {
          en: 'At night on motorways only',
          nl: "'s Nachts alleen op autosnelwegen",
          ar: 'ليلا على الطرق السريعة فقط',
        },
      },
    ],
    correctAnswerId: 'q-nv-8o2',
    explanation: {
      en: 'Use rear fog lights only when visibility is seriously reduced. They can dazzle following drivers; switch them off when visibility improves.',
      nl: 'Gebruik mistlicht achter alleen wanneer het zicht ernstig is beperkt. Het kan volgende bestuurders verblinden; schakel het uit wanneer het zicht verbetert.',
      ar: 'استخدم مصابيح الضباب الخلفية فقط عندما تنخفض الرؤية بشكل كبير. قد تعمي السائقين خلفك؛ أطفئها عند تحسن الرؤية.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-9',
    text: {
      en: 'Why should you clean your windscreen and lights regularly?',
      nl: 'Waarom moet u uw voorruit en verlichting regelmatig schoonmaken?',
      ar: 'لماذا يجب تنظيف الزجاج الأمامي والمصابيح بانتظام؟',
    },
    options: [
      {
        id: 'q-nv-9o1',
        text: {
          en: 'To improve fuel economy',
          nl: 'Om het brandstofverbruik te verbeteren',
          ar: 'لتحسين استهلاك الوقود',
        },
      },
      {
        id: 'q-nv-9o2',
        text: {
          en: 'Dirt and grime reduce visibility and make lights less effective',
          nl: 'Vuil en aanslag beperken het zicht en maken de verlichting minder effectief',
          ar: 'الأوساخ تقلل الرؤية وتضعف فعالية الإضاءة',
        },
      },
      {
        id: 'q-nv-9o3',
        text: {
          en: 'It is only required in winter',
          nl: 'Het is alleen in de winter verplicht',
          ar: 'ذلك مطلوب في الشتاء فقط',
        },
      },
    ],
    correctAnswerId: 'q-nv-9o2',
    explanation: {
      en: 'A dirty windscreen scatters light and reduces visibility. Dirty lights reduce your ability to see and be seen.',
      nl: 'Een vuile voorruit verstrooit licht en beperkt het zicht. Vuile lampen beperken uw vermogen om te zien en gezien te worden.',
      ar: 'الزجاج القذر يشتت الضوء ويقلل الرؤية. المصابيح المتسخة تقلل قدرتك على الرؤية والظهور للآخرين.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-10',
    text: {
      en: 'You are driving at night and your headlights suddenly fail. What should you do?',
      nl: 'U rijdt \'s nachts en uw koplampen vallen plotseling uit. Wat moet u doen?',
      ar: 'أنت تقود ليلا وفجأة تتعطل مصابيحك الأمامية. ماذا تفعل؟',
    },
    options: [
      {
        id: 'q-nv-10o1',
        text: {
          en: 'Continue at the same speed',
          nl: 'Met dezelfde snelheid verder rijden',
          ar: 'أن تواصل بنفس السرعة',
        },
      },
      {
        id: 'q-nv-10o2',
        text: {
          en: 'Slow down, pull off the road when safe, and use hazard lights and sidelights if available',
          nl: 'Vertragen, de weg verlaten wanneer het veilig is, en waarschuwingslichten en stadslicht gebruiken indien beschikbaar',
          ar: 'أن تبطئ وتنسحب إلى جانب الطريق عند الأمان وتستخدم أضواء التحذير والإضاءة الجانبية إن وجدت',
        },
      },
      {
        id: 'q-nv-10o3',
        text: {
          en: 'Use the horn and continue',
          nl: 'Claxonneren en verder rijden',
          ar: 'أن تستخدم البوق وتتابع',
        },
      },
    ],
    correctAnswerId: 'q-nv-10o2',
    explanation: {
      en: 'If headlights fail, reduce speed, pull off the road when safe, and use hazard lights and sidelights. Get the fault fixed before driving again.',
      nl: 'Als de koplampen uitvallen, vertraagt u, verlaat u de weg wanneer het veilig is, en gebruikt u waarschuwingslichten en stadslicht. Laat de storing herstellen voordat u weer rijdt.',
      ar: 'إذا تعطلت المصابيح الأمامية، خفف السرعة وانسحب إلى جانب الطريق عند الأمان واستخدم أضواء التحذير والإضاءة الجانبية. أصلح العطل قبل القيادة مجددا.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-11',
    text: {
      en: 'What is "night blindness" in driving terms?',
      nl: "Wat is 'nachtblindheid' in rijtermen?",
      ar: 'ما المقصود بـ«عمى الليل» في سياق القيادة؟',
    },
    options: [
      {
        id: 'q-nv-11o1',
        text: {
          en: 'Being afraid of the dark',
          nl: 'Bang zijn in het donker',
          ar: 'الخوف من الظلام',
        },
      },
      {
        id: 'q-nv-11o2',
        text: {
          en: 'Eyes taking time to adjust when moving from lit to unlit areas (or vice versa)',
          nl: 'Dat de ogen tijd nodig hebben om zich aan te passen bij overgang van verlicht naar onverlicht (of omgekeerd)',
          ar: 'احتياج العينين إلى وقت للتكيف عند الانتقال من منطقة مضاءة إلى مظلمة أو العكس',
        },
      },
      {
        id: 'q-nv-11o3',
        text: {
          en: 'Driving without lights',
          nl: 'Rijden zonder verlichting',
          ar: 'القيادة دون إضاءة',
        },
      },
    ],
    correctAnswerId: 'q-nv-11o2',
    explanation: {
      en: 'When you move from bright to dark (or dark to bright), your eyes need time to adapt. Slow down until your vision has adjusted.',
      nl: 'Als u van licht naar donker gaat (of omgekeerd), hebben uw ogen tijd nodig om zich aan te passen. Vertraag totdat uw zicht is aangepast.',
      ar: 'عند الانتقال من الإضاءة القوية إلى الظلام (أو العكس) تحتاج عيناك إلى وقت للتكيف. أبطئ حتى تتكيف رؤيتك.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-12',
    text: {
      en: 'When may you use your hazard warning lights while moving?',
      nl: 'Wanneer mag u uw waarschuwingslichten gebruiken tijdens het rijden?',
      ar: 'متى يجوز لك استخدام أضواء التحذير أثناء الحركة؟',
    },
    options: [
      {
        id: 'q-nv-12o1',
        text: {
          en: 'Whenever it is dark',
          nl: 'Wanneer het maar donker is',
          ar: 'كلما كان الظلام',
        },
      },
      {
        id: 'q-nv-12o2',
        text: {
          en: 'To warn of a temporary obstruction (e.g. on a motorway) when allowed by law',
          nl: 'Om te waarschuwen voor een tijdelijke obstructie (bijv. op een autosnelweg) wanneer de wet dit toestaat',
          ar: 'لتحذير من عائق مؤقت (مثلا على طريق سريع) عندما يسمح القانون بذلك',
        },
      },
      {
        id: 'q-nv-12o3',
        text: {
          en: 'In rain or fog',
          nl: 'Bij regen of mist',
          ar: 'في المطر أو الضباب',
        },
      },
    ],
    correctAnswerId: 'q-nv-12o2',
    explanation: {
      en: 'Hazard lights may be used while moving only in specific situations (e.g. to warn of a hazard on a motorway). Rules vary; use when legally allowed.',
      nl: 'Waarschuwingslichten mag u tijdens het rijden alleen in specifieke situaties gebruiken (bijv. om te waarschuwen voor een gevaar op een autosnelweg). De regels verschillen; gebruik ze wanneer de wet dit toestaat.',
      ar: 'يسمح باستخدام أضواء التحذير أثناء الحركة فقط في حالات محددة (مثل التحذير من خطر على طريق سريع). تختلف القواعد؛ استخدمها عندما يسمح القانون.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-13',
    text: {
      en: 'Why should you reduce speed when driving at night on an unlit road?',
      nl: 'Waarom moet u uw snelheid verlagen als u \'s nachts op een onverlichte weg rijdt?',
      ar: 'لماذا يجب تخفيف السرعة عند القيادة ليلا على طريق غير مضاء؟',
    },
    options: [
      {
        id: 'q-nv-13o1',
        text: {
          en: 'To save fuel',
          nl: 'Om brandstof te besparen',
          ar: 'لتوفير الوقود',
        },
      },
      {
        id: 'q-nv-13o2',
        text: {
          en: 'You can only see as far as your headlights; you must be able to stop within that distance',
          nl: 'U kunt slechts zo ver zien als uw koplampen reiken; u moet binnen die afstand kunnen stoppen',
          ar: 'ترى فقط بقدر ما تصل إليه مصابيحك؛ يجب أن تتمكن من التوقف ضمن تلك المسافة',
        },
      },
      {
        id: 'q-nv-13o3',
        text: {
          en: 'Wildlife only come out at night',
          nl: 'Wild komt alleen \'s nachts tevoorschijn',
          ar: 'الحياة البرية تخرج ليلا فقط',
        },
      },
    ],
    correctAnswerId: 'q-nv-13o2',
    explanation: {
      en: 'On an unlit road you can only see as far as your headlights. You must be able to stop within the distance you can see to be clear.',
      nl: 'Op een onverlichte weg kunt u slechts zo ver zien als uw koplampen. U moet binnen de afstand die u vrij kunt overzien kunnen stoppen.',
      ar: 'على طريق غير مضاء ترى فقط بقدر ما تضيء مصابيحك. يجب أن تتمكن من التوقف ضمن المسافة التي تراها واضحة أمامك.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-limited-visibility.jpg',
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-14',
    text: {
      en: 'What should you do if you see a pedestrian wearing dark clothing at night?',
      nl: 'Wat moet u doen als u \'s nachts een voetganger in donkere kleding ziet?',
      ar: 'ماذا تفعل إذا رأيت مشاة يرتدون ملابس داكنة ليلا؟',
    },
    options: [
      {
        id: 'q-nv-14o1',
        text: {
          en: 'Assume they will stay on the pavement',
          nl: 'Ervan uitgaan dat zij op het trottoir blijven',
          ar: 'أن تفترض أنهم سيبقون على الرصيف',
        },
      },
      {
        id: 'q-nv-14o2',
        text: {
          en: 'Slow down and be prepared to stop; they are hard to see',
          nl: 'Vertragen en gereed zijn om te stoppen; zij zijn moeilijk te zien',
          ar: 'أن تبطئ وتستعد للتوقف؛ يصعب رؤيتهم',
        },
      },
      {
        id: 'q-nv-14o3',
        text: {
          en: 'Flash your lights to warn them',
          nl: 'Met uw lichten flitsen om hen te waarschuwen',
          ar: 'أن تومض بالأضواء لتحذيرهم',
        },
      },
    ],
    correctAnswerId: 'q-nv-14o2',
    explanation: {
      en: 'Pedestrians in dark clothing are difficult to see at night. Slow down and be ready to stop; they may step into the road.',
      nl: 'Voetgangers in donkere kleding zijn \'s nachts moeilijk te zien. Vertraag en wees gereed om te stoppen; zij kunnen de rijbaan op stappen.',
      ar: 'يصعب رؤية المشاة بملابس داكنة ليلا. أبطئ واستعد للتوقف؛ قد يخطون إلى الطريق.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-dark-pedestrian.jpg',
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-15',
    text: {
      en: 'When driving in fog, what should you do?',
      nl: 'Wat moet u doen bij rijden in mist?',
      ar: 'ماذا تفعل عند القيادة في الضباب؟',
    },
    options: [
      {
        id: 'q-nv-15o1',
        text: {
          en: 'Use main beam for better visibility',
          nl: 'Groot licht gebruiken voor beter zicht',
          ar: 'استخدام الضوء العالي لرؤية أفضل',
        },
      },
      {
        id: 'q-nv-15o2',
        text: {
          en: 'Use dipped headlights and fog lights if needed; slow down and keep a safe distance',
          nl: 'Dimlicht en indien nodig mistlicht gebruiken; vertragen en veilige afstand houden',
          ar: 'استخدام المصابيح المنخفضة ومصابيح الضباب عند الحاجة؛ الإبطاء والحفاظ على مسافة آمنة',
        },
      },
      {
        id: 'q-nv-15o3',
        text: {
          en: 'Drive close to the vehicle in front to follow their lights',
          nl: 'Dicht achter het voertuig voor u rijden om hun lichten te volgen',
          ar: 'القيادة قرب المركبة الأمامية لتتبع أضوائها',
        },
      },
    ],
    correctAnswerId: 'q-nv-15o2',
    explanation: {
      en: 'In fog use dipped headlights and fog lights if visibility is poor. Slow down and keep a safe distance. Main beam reflects off fog and reduces visibility.',
      nl: 'Gebruik in mist dimlicht en mistlicht als het zicht slecht is. Vertraag en houd een veilige afstand. Groot licht weerkaatst in de mist en beperkt het zicht.',
      ar: 'في الضباب استخدم المصابيح المنخفضة ومصابيح الضباب إذا كانت الرؤية ضعيفة. أبطئ واحتفظ بمسافة آمنة. ينعكس الضوء العالي في الضباب ويقلل الرؤية.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-fog-driving.jpg',
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-16',
    text: {
      en: 'Why should you avoid looking directly at oncoming headlights?',
      nl: 'Waarom moet u vermijden recht in tegemoetkomende koplampen te kijken?',
      ar: 'لماذا يجب تجنب النظر مباشرة إلى مصابيح المركبات المقابلة؟',
    },
    options: [
      {
        id: 'q-nv-16o1',
        text: {
          en: 'It is rude',
          nl: 'Het is onbeleefd',
          ar: 'ذلك وقاحة',
        },
      },
      {
        id: 'q-nv-16o2',
        text: {
          en: 'It causes temporary blindness and you may lose your sense of direction',
          nl: 'Het veroorzaakt tijdelijke verblinding en u kunt uw richtinggevoel verliezen',
          ar: 'يسبب عمى مؤقتا وقد تفقد إحساسك بالاتجاه',
        },
      },
      {
        id: 'q-nv-16o3',
        text: {
          en: 'It damages the eyes permanently',
          nl: 'Het beschadigt de ogen permanent',
          ar: 'يضر العينين بشكل دائم',
        },
      },
    ],
    correctAnswerId: 'q-nv-16o2',
    explanation: {
      en: 'Looking at oncoming headlights causes glare and temporary blindness. Look toward the left edge of the road until the vehicle has passed.',
      nl: 'Kijken naar tegemoetkomende koplampen veroorzaakt verblinding en tijdelijke blindheid. Kijk naar de linker kant van de weg totdat het voertuig is gepasseerd.',
      ar: 'النظر إلى مصابيح المركبات المقابلة يسبب وهجا وعمى مؤقتا. انظر نحو الحافة اليسرى للطريق حتى تمر المركبة.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-17',
    text: {
      en: 'When may you drive with only sidelights (parking lights) at night?',
      nl: 'Wanneer mag u \'s nachts alleen met stadslicht (parkeerlicht) rijden?',
      ar: 'متى يجوز لك القيادة ليلا بإضاءة المواقف (الأضواء الجانبية) فقط؟',
    },
    options: [
      {
        id: 'q-nv-17o1',
        text: {
          en: 'On well-lit urban roads',
          nl: 'Op goed verlichte stadswegen',
          ar: 'على طرق حضرية مضاءة جيدا',
        },
      },
      {
        id: 'q-nv-17o2',
        text: {
          en: 'Sidelights alone are not sufficient for driving at night; use dipped headlights',
          nl: 'Alleen stadslicht is onvoldoende om \'s nachts te rijden; gebruik dimlicht',
          ar: 'الإضاءة الجانبية وحدها غير كافية للقيادة ليلا؛ استخدم المصابيح المنخفضة',
        },
      },
      {
        id: 'q-nv-17o3',
        text: {
          en: 'On motorways',
          nl: 'Op autosnelwegen',
          ar: 'على الطرق السريعة',
        },
      },
    ],
    correctAnswerId: 'q-nv-17o2',
    explanation: {
      en: 'Sidelights are for parking. When driving at night you must use dipped headlights (or main beam where appropriate) so you can see and be seen.',
      nl: 'Stadslicht is bedoeld voor parkeren. Als u \'s nachts rijdt, moet u dimlicht (of waar passend groot licht) gebruiken, zodat u kunt zien en gezien wordt.',
      ar: 'الإضاءة الجانبية للوقوف. عند القيادة ليلا يجب استخدام المصابيح المنخفضة (أو العالي حيث يلزم) حتى ترى ويراك الآخرون.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-18',
    text: {
      en: 'What should you do when approaching a tunnel in daylight?',
      nl: 'Wat moet u doen bij het naderen van een tunnel bij daglicht?',
      ar: 'ماذا تفعل عند الاقتراب من نفق في النهار؟',
    },
    options: [
      {
        id: 'q-nv-18o1',
        text: {
          en: 'Switch off all lights',
          nl: 'Alle verlichting uitschakelen',
          ar: 'إطفاء جميع الأضواء',
        },
      },
      {
        id: 'q-nv-18o2',
        text: {
          en: 'Switch on dipped headlights before entering; visibility drops inside',
          nl: 'Voor het binnenrijden dimlicht inschakelen; het zicht neemt binnen af',
          ar: 'تشغيل المصابيح المنخفضة قبل الدخول؛ الرؤية تقل داخل النفق',
        },
      },
      {
        id: 'q-nv-18o3',
        text: {
          en: 'Speed up to pass through quickly',
          nl: 'Versnellen om er snel doorheen te komen',
          ar: 'زيادة السرعة للمرور بسرعة',
        },
      },
    ],
    correctAnswerId: 'q-nv-18o2',
    explanation: {
      en: 'Turn on dipped headlights before entering a tunnel so you can see and be seen as visibility drops.',
      nl: 'Schakel dimlicht in voordat u een tunnel inrijdt, zodat u kunt zien en gezien wordt wanneer het zicht afneemt.',
      ar: 'شغل المصابيح المنخفضة قبل دخول النفق حتى ترى ويراك الآخرون عند انخفاض الرؤية.',
    },
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/night-visibility/night-tunnel-approach.jpg',
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-19',
    text: {
      en: 'Why is wet road surface more dangerous at night?',
      nl: 'Waarom is een nat wegdek \'s nachts gevaarlijker?',
      ar: 'لماذا يكون الطريق المبلل أكثر خطورة ليلا؟',
    },
    options: [
      {
        id: 'q-nv-19o1',
        text: {
          en: 'Water cools the engine',
          nl: 'Water koelt de motor af',
          ar: 'الماء يبرد المحرك',
        },
      },
      {
        id: 'q-nv-19o2',
        text: {
          en: 'Reflections from street lights and headlights make it harder to see; grip is also reduced',
          nl: 'Reflecties van straatverlichting en koplampen maken het moeilijker om te zien; de grip is ook verminderd',
          ar: 'انعكاسات إنارة الشوارع والمصابيح تجعل الرؤية أصعب؛ كما يقل الالتصاق',
        },
      },
      {
        id: 'q-nv-19o3',
        text: {
          en: 'It is not more dangerous',
          nl: 'Het is niet gevaarlijker',
          ar: 'ليس أكثر خطورة',
        },
      },
    ],
    correctAnswerId: 'q-nv-19o2',
    explanation: {
      en: 'Wet roads reduce grip. At night, reflections from lights can make it harder to see the road and other vehicles.',
      nl: 'Nat wegdek vermindert de grip. \'s Nachts kunnen reflecties van licht het moeilijker maken om de weg en andere voertuigen te zien.',
      ar: 'الطرق المبللة تقلل الالتصاق. ليلا قد تجعل انعكاسات الأضواء رؤية الطريق والمركبات الأخرى أصعب.',
    },
    subject: 'Night & Visibility',
  },
  {
    id: 'q-nv-20',
    text: {
      en: 'You are driving at dusk. When should you turn on your headlights?',
      nl: 'U rijdt bij schemering. Wanneer moet u uw koplampen inschakelen?',
      ar: 'أنت تقود عند الغسق. متى يجب تشغيل المصابيح الأمامية؟',
    },
    options: [
      {
        id: 'q-nv-20o1',
        text: {
          en: 'Only when it is completely dark',
          nl: 'Alleen wanneer het volledig donker is',
          ar: 'فقط عندما يحل الظلام تماما',
        },
      },
      {
        id: 'q-nv-20o2',
        text: {
          en: 'When visibility is reduced so that you or others need lights to see and be seen',
          nl: 'Wanneer het zicht zodanig is beperkt dat u of anderen verlichting nodig hebben om te zien en gezien te worden',
          ar: 'عندما تقل الرؤية بحيث تحتاج أنت أو غيرك إلى الأضواء للرؤية والظهور',
        },
      },
      {
        id: 'q-nv-20o3',
        text: {
          en: 'Lights are not needed at dusk',
          nl: 'Bij schemering is verlichting niet nodig',
          ar: 'لا حاجة للأضواء عند الغسق',
        },
      },
    ],
    correctAnswerId: 'q-nv-20o2',
    explanation: {
      en: 'Turn on headlights when visibility is reduced (e.g. at dusk or in rain) so you can see and be seen by others.',
      nl: 'Schakel de koplampen in wanneer het zicht is beperkt (bijv. bij schemering of regen), zodat u kunt zien en door anderen gezien wordt.',
      ar: 'شغل المصابيح الأمامية عندما تقل الرؤية (مثل الغسق أو المطر) حتى ترى ويراك الآخرون.',
    },
    subject: 'Night & Visibility',
  },
];
